module.exports = __webpack_public_path__ + "static/img/Daniel.ea53760.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/photos/board/Daniel.jpg
// module id = gx8e
// module chunks = 0